if (!customElements.get("collections-stack")) {
  customElements.define(
    "collections-stack",
    class extends HTMLElement {
      constructor() {
        super();
        this.triggerBtn = this.querySelector(`[id^="LoadMore-Trigger-"]`);
        const collectionId = this.triggerBtn?.id?.replace(
          "LoadMore-Trigger-",
          "",
        );
        const sectionId = this.triggerBtn?.getAttribute("data-section-id");
        const currentPage = parseInt(
          this.triggerBtn?.getAttribute("data-current-page") || "1",
        );

        this.triggerBtn?.addEventListener("click", async () => {
          await this.handleFetchData(collectionId, sectionId, currentPage);
        });
      }

      async handleFetchData(collectionId, sectionId, currentPage) {
        const spinner = this.triggerBtn.querySelector(".loading__spinner");
        spinner.classList.remove("hidden");
        fetch(
          window.location.origin +
            `?sections=${sectionId}&page=${currentPage + 1}`,
        )
          .then((res) => res.json())
          .then((res) => res?.[sectionId])
          .then((res) => {
            if (!res) return;
            const html = new DOMParser().parseFromString(res, "text/html");
            const currentProducts = html.querySelector(
              `[data-collection-id="${collectionId}"]`,
            ).innerHTML;
            const currentPageFromResponse = parseInt(
              this.triggerBtn.getAttribute("data-current-page") || "1",
            );
            this.querySelector(
              `[data-collection-id='${collectionId}']`,
            ).innerHTML += currentProducts;
            if (currentPageFromResponse === currentPage) {
              this.querySelector(
                `[id="LoadMore-Trigger-${collectionId}"]`,
              ).parentElement.remove();
            }
          })
          .then(() => {
            spinner.classList.add("hidden");
          });
      }
    },
  );
}
